import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import { fetchEpcIdData } from "./Members/FetchEpcId";

export const getMembersDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  registeredUsers: [
    {
      fieldName: "EPC Id",
      fieldValue: "epcId",
      className: "col-span-6",
      type: "text",
      name: "epcId",
      formType: "select",
      label: "EPC Id",
      placeholder: "Enter EPC Id",
      validation: { required: "EPC Id is required" },
      loadOptions: fetchEpcIdData,
    },
    // {
    //   fieldName: "User Name",
    //   fieldValue: "userName",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "userName",
    //   formType: "input",
    //   label: "User Name",
    //   placeholder: "Enter User Name",
    //   validation: { required: "User Name is required" },
    // },
    {
      fieldName: "Name",
      fieldValue: "firstName",
      className: "col-span-6",
      type: "text",
      name: "firstName",
      formType: "input",
      label: "Name",
      placeholder: "Enter Name",
      validation: { required: "Name is required" },
    },
    {
      fieldName: "Email",
      fieldValue: "emailAddress",
      className: "col-span-6",
      type: "text",
      name: "emailAddress",
      formType: "input",
      label: "Email",
      placeholder: "Enter Email",
      validation: { required: "Email is required" },
    },
    // {
    //   fieldName: "Date Of Birth",
    //   fieldValue: "dateOfBirth",
    //   className: "col-span-6",
    //   type: "date",
    //   name: "dateOfBirth",
    //   formType: "date",
    //   label: "Date Of Birth",
    //   placeholder: "Enter Date Of Birth",
    //   validation: { required: "Date Of Birth is required" },
    // },
    // {
    //   fieldName: "Passport Number",
    //   fieldValue: "passportNumber",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "passportNumber",
    //   formType: "input",
    //   label: "Passport Number",
    //   placeholder: "Enter Passport Number",
    //   validation: { required: "Passport Number is required" },
    // },
    // {
    //   fieldName: "NRIC",
    //   fieldValue: "nric",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "nric",
    //   formType: "input",
    //   label: "NRIC",
    //   placeholder: "Enter NRIC",
    //   validation: { required: "NRIC is required" },
    // },

    // {
    //   fieldName: "Subscription Status",
    //   fieldValue: "subscription",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "subscription",
    //   formType: "input",
    //   label: "Subscription Status",
    //   placeholder: "Enter Subscription",
    //   validation: { required: "Subscription is required" },
    // },
  ],
};
